import styled from "styled-components";
import Plus from "../../../assets/icons/plus.svg";
// #region SCOPED CSS
const StyledBtn = styled.div`
    .add-field-button {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        width: 80px;
        height: 25px;
        cursor: pointer;
        margin-top: 10px;
        border: 1px solid rgba(79, 91, 109, 1);
    }
    img {
        width: 16px;
        height: 16px;
    }
`;
// #endregion SCOPED CSS

/**
 * AddFieldBtn Component
 *
 * A reusable button component styled with styled-components, displaying a plus icon.
 * Typically used for adding new fields or items in a form or list.
 *
 * Props:
 * @param {Object} props - The component props.
 * @param {Object} [props.style={}] - Additional inline styles to apply to the button.
 * @param {string} [props.className=""] - Additional CSS class names to apply to the button.
 * @param {Function} [props.onClick] - The callback function to be executed when the button is clicked.
 */

const AddFieldBtn = ({ onClick, style = {}, className = "" }) => {
    return (
        <StyledBtn>
            <div className={`add-field-button ${className}`} onClick={onClick} style={{ ...style }}>
                <img src={Plus} alt="alt" />
            </div>
        </StyledBtn>
    );
};
export default AddFieldBtn;
